export default class AssignmentActions {

    static BEFORE_ASSIGN='BEFORE_ASSIGN'
    static AFTER_ASSIGN='AFTER_ASSIGN'

    static BEFORE_REVOKE=''
    static AFTER_REVOKE='AFTER_REVOKE'

    static beforeAssign(){
      return {
        type: AssignmentActions.BEFORE_ASSIGN
      };
    }

    static afterAssign(data){
      return {
        type: AssignmentActions.AFTER_ASSIGN,
        payload:data
      };
    }

    static beforeRevoke(){
      return {
        type: AssignmentActions.BEFORE_REVOKE
      };
    }

    static afterRevoke(data){
      return {
        type: AssignmentActions.AFTER_REVOKE,
        payload:data
      };
    }


  


    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static RESET_LIST='RESET_LIST';
    static GET_HELPER='GET_HELPER';




    static submit(){
      return {
        type: AssignmentActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: AssignmentActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: AssignmentActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: AssignmentActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: AssignmentActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: AssignmentActions.SHOW_DATA,
        payload: data
      };
    }
    static resetList() {
      return {
        type: AssignmentActions.RESET_LIST
      };
    }
    static error(error){
      return {
        type: AssignmentActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: AssignmentActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: AssignmentActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: AssignmentActions.RESET_DATA,
      };
    }
    static errorInternal(error){
      return {
        type: AssignmentActions.ERROR_SERVER,
        payload: error
      };
    }
    static helper(data){
        return {
          type: AssignmentActions.GET_HELPER,
          payload: data
        };
      }
  }
  
  